var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upscales_1705636789625 1",
    clipPath: "url(#clip0_1600_6829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.8388 9.28005C36.5188 10.8659 33.4529 12.3248 30.3894 13.7953C27.4624 15.2 24.5612 16.6636 21.5988 17.9906C20.9706 18.273 20.0035 18.3553 19.4059 18.0753C13.5588 15.3389 7.75647 12.5059 1.94471 9.69652C1.70941 9.58358 1.49529 9.42593 1.09294 9.18122C1.9 8.74828 2.55647 8.3624 3.24118 8.03534C8.49765 5.51534 13.7682 3.02122 19.0153 0.480049C20.0106 -0.00230429 20.8365 -0.00701018 21.8671 0.501225C27.4812 3.27064 33.14 5.94828 38.7823 8.66358C39.0529 8.79299 39.3023 8.96711 39.8365 9.28005H39.8388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.9706 19.9837C37.0435 21.3743 34.4741 22.5885 31.907 23.8167C28.38 25.5037 24.8694 27.2214 21.3235 28.8661C20.8553 29.0826 20.1235 29.1532 19.6788 28.9414C13.7 26.1273 7.75173 23.252 1.79644 20.3861C1.59879 20.2896 1.41997 20.1485 1.00585 19.8802C2.88115 18.9955 4.54467 18.1696 6.25291 17.4449C6.57056 17.3108 7.09997 17.5061 7.46703 17.6802C11.2129 19.4567 14.9564 21.2402 18.6764 23.0708C19.8176 23.6308 20.8364 23.692 22.0176 23.1085C25.7329 21.2708 29.5 19.5367 33.2317 17.7296C34.0059 17.3555 34.6694 17.3179 35.4459 17.7414C36.8106 18.4826 38.2294 19.1273 39.9706 19.9837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.8835 30.7527C36.6599 32.3103 33.7494 33.7221 30.8341 35.1197C27.6599 36.6421 24.4976 38.188 21.2905 39.6374C20.7847 39.8656 19.9847 39.8374 19.4764 39.5997C13.8082 36.9456 8.16818 34.2256 2.52347 31.5174C2.08112 31.3056 1.66465 31.0327 1.03642 30.6727C2.80818 29.8044 4.35171 28.9691 5.96583 28.308C6.41995 28.1221 7.13759 28.3197 7.63642 28.5527C11.4717 30.3315 15.2929 32.1409 19.0905 33.9974C20.0317 34.4562 20.8505 34.435 21.7658 33.9903C25.3588 32.2468 28.9823 30.5668 32.5588 28.7974C33.7752 28.195 34.8364 27.988 36.0694 28.7856C37.1729 29.4985 38.4105 30.0068 39.8835 30.7527Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_6829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.0588,
    height: 40,
    fill: "white",
    transform: "translate(0.970581)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuffer);
export default __webpack_public_path__ + "static/media/Buffer.bd1b588a8d5299997375bb3a5a22a074.svg";
export { ForwardRef as ReactComponent };